/* eslint-disable padding-line-between-statements */
import { Loader, useModal } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { CreditCardUtil } from '@xengage/gw-portals-util-js';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from 'react';
import { IntlContext } from 'react-intl';
import { useTranslator } from '@jutro/locale';
import { TFPACustomQuoteService } from 'tfpa-capability-quoteandbind-residential';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import metadata from './PaymentDetailsPage.metadata.json5';
import messages from './PaymentDetailsPage.messages';
import styles from './PaymentDetailsPage.module.scss'
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';

import { RadioField } from '@jutro/legacy/components';

const PAYMENT_METHOD = {
    bank: 'wire',
    credit: 'creditcard',
};


function initialiseVM(submissionVM) {
    // submissionVM.bindData?.paymentDetails?.value = {};
    // submissionVM.bindData.paymentDetails.value || {};
}
/* eslint-enable no-param-reassign */

function TFPAPaymentDetailsPage(props) {
    const {
        wizardData: submissionVM,
        updateWizardData,
        wizardSnapshot,
        history
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, updateIsLoading] = useState(false);
    const [isVMInitialised, updateIsVMInitialised] = useState(false);
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [hasRetrievedPaymentPlans, updateHasRetrievedPaymentPlans] =
        useState(false);
    const { isComponentValid, registerComponentValidation } =
        useValidation('TFPAPaymentDetailsPage');
    const intlContext = useContext(IntlContext);
    const translator = useTranslator();
    const { showAlert, showConfirm } = useModal();
    const [showSubmitLoader, setShowSubmitLoader] = useState(false);

    useEffect(() => {
        if (!isVMInitialised) {
            initialiseVM(submissionVM);
            updateIsVMInitialised(true);
        }
    }, [isVMInitialised, submissionVM]);

    const getTotalCurrencyFormat = useCallback((item) => {

        const formatterCurrency = intlContext.formatNumber(item.total?.amount, {
            style: 'currency',
            currency: item.total?.currency
        });

        return formatterCurrency
    }, [intlContext])

    const getdownPayCurrencyFormat = useCallback((item) => {

        const formatterCurrency = intlContext.formatNumber(item.downPayment?.amount, {
            style: 'currency',
            currency: item.total?.currency
        });

        return formatterCurrency
    }, [intlContext])

    const getInstallmentCurrencyFormat = useCallback((item) => {

        const formatterCurrency = intlContext.formatNumber(item.installment?.amount, {
            style: 'currency',
            currency: item.total?.currency
        });

        return formatterCurrency
    }, [intlContext])

    const onRowClick = useCallback((rowData, index) => {

        _.set(submissionVM, 'bindData_TFPA.selectedPaymentPlan.value', rowData.billingId)
        updateWizardData(submissionVM)
    }, [submissionVM, updateWizardData])

    // DE16564
    const getPayorPersonName = () => {
        const firstName = _.get(submissionVM, 'bindData_TFPA.payor_Ext.accountContactDTO.firstName.value');
        const lastName = _.get(submissionVM, 'bindData_TFPA.payor_Ext.accountContactDTO.lastName.value');

        return `${firstName} ${lastName}`
    };


    const handleNext = useCallback(async () => {
        if (_.isUndefined(_.get(submissionVM, 'bindData_TFPA.selectedPaymentPlan.value'))) {
            showAlert({
                title: translator(messages.paymentPlanAlertTitle),
                message: translator(messages.paymentPlanAlertMessage),
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: "Close",
            })

            return false
        }

        const proceedConfirm = await showConfirm({
            title: messages.confirmTransaction,
            message: messages.confirmTransactionMsg,
            status: 'warning',
            icon: 'gw-help',
            confirmButtonText: commonMessages.ok,
            cancelButtonText: commonMessages.cancelModel,
        });

        if (proceedConfirm === 'cancel' || proceedConfirm === 'close') {
            return false;
        }

        const ChosenQuotePublicID = _.get(submissionVM, 'quoteData.offeredQuotes.value[0].publicID')

        _.set(submissionVM, 'bindData_TFPA.chosenQuote.value', ChosenQuotePublicID)
        _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.yourHome.additionalInterests.children[0].policyAdditionalInterest.emailAddress1', 
        submissionVM.value.bindData_TFPA.contactEmail)
        updateWizardData(submissionVM)
        setShowSubmitLoader(true);

        try {
            if(submissionVM.bindData_TFPA.payorType_Ext.value.code === 'mortgage' || submissionVM.bindData_TFPA.payorType_Ext.value.code === "mortgageeescrow") {
                const result = await TFPACustomQuoteService.bind(
                    submissionVM.value,
                    authHeader
                );
    
                _.set(submissionVM, 'value', result);
                updateWizardData(submissionVM);
                setShowSubmitLoader(false);
    
                submissionVM.noCancelWarning = true;
                return history.push({
                    pathname: '/tfpaResConfirmation',
                    state: {
                        result,
                        authHeader
                    },
                });
    
                // return submissionVM;
            } else {
                const result = await TFPACustomQuoteService.submit(
                    submissionVM.value,
                    authHeader
                );
    
                _.set(submissionVM, 'value', result);
                updateWizardData(submissionVM);
                setShowSubmitLoader(false);
    
                submissionVM.noCancelWarning = true;
                return history.push({
                    pathname: '/tfpaResConfirmation',
                    state: {
                        result,
                        authHeader
                    },
                });
    
            }
            
        } catch (error) {
            setShowSubmitLoader(false);

            if (error.data) {
                // DE16371
                const errorMessage = _.split(error.message, 'ErrorMessage: ')[1];
                const errorCode = _.get(error.data, 'appErrorCode');

                // eslint-disable-next-line default-case
                switch (errorCode) {
                    case 602:
                        showAlert({
                            title: messages.uwIssueTitle,
                            message: messages.uwIssueMessage,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: messages.uwActionLabel,
                        }).then(() => {
                            // 2024-12-29 - Debra Frum - DE17673 - Suppress the Exit confirmation popup
                            submissionVM.noCancelWarning = true;
                            history.push(`${process.env.PUBLIC_PATH}/quotes/${submissionVM.quoteID.value}/summary`)
                        })
                        break;
                    case 601:
                        showAlert({
                            title: messages.uwIssueTitle,
                            message: messages.uwIssueMessage,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: messages.uwActionLabel,
                        }).then(() => {
                            // 2024-12-29 - Debra Frum - DE17673 - Suppress the Exit confirmation popup
                            submissionVM.noCancelWarning = true;
                            history.push(`${process.env.PUBLIC_PATH}/quotes/${submissionVM.quoteID.value}/summary`)
                        })
                        break;
                    default:
                        ErrorPopupUtil.showSaveErrorPopup(showAlert, false)
                        break;
                }
            }
            
            return false;
        }

    }, []);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getTotalCurrencyFormat,
            getdownPayCurrencyFormat,
            getInstallmentCurrencyFormat,
            onRowClick
        },
    };


    const overrideProps = {
        '@field': {
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        paymentPlanTable: {
            data: _.get(submissionVM, 'bindData_TFPA.paymentPlans.value'),
            selectedRows: [_.findIndex(submissionVM.bindData_TFPA.paymentPlans.value, (plan) =>
                plan.billingId === submissionVM.bindData_TFPA.selectedPaymentPlan.value)]
        },
        payorPerson: {
            visible: _.get(submissionVM, 'bindData_TFPA.payor_Ext.accountContactDTO.subtype.value') === 'Person',
            value: getPayorPersonName()
        },
        payorCompany: {
            visible: _.get(submissionVM, 'bindData_TFPA.payor_Ext.accountContactDTO.subtype.value') === 'Company',
            value: _.get(submissionVM, 'bindData_TFPA.payor_Ext.accountContactDTO.contactName.value')
        },
        payorType: {
            value: translator({
                id: `typekey.PaymentPayorType_Ext.${_.get(submissionVM, 'bindData_TFPA.payorType_Ext.value.code')}`,
                defaultMessage: `typekey.PaymentPayorType_Ext.${_.get(submissionVM, 'bindData_TFPA.payorType_Ext.value.code')}`,
            }),
        }
    };


    return (
        <WizardPage
            nextLabel={messages.paymentBuyNow}
            onNext={handleNext}
            disableNext={!isComponentValid}
            showNext={!showSubmitLoader}
            showPrevious={!showSubmitLoader}
            showCancel={!showSubmitLoader}
            hideHeader={showSubmitLoader}
        >
            {!showSubmitLoader ? 
            (<Loader loaded={!isLoading}>
                <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
            </Loader>) : 
            (<Loader
                loaded={!showSubmitLoader}
                text="Processing Transaction..."
            />)}
        </WizardPage>
    );
}

TFPAPaymentDetailsPage.propTypes = wizardProps;
TFPAPaymentDetailsPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};
export default withAuthenticationContext(withRouter(TFPAPaymentDetailsPage));
